<template>
  <validation-observer
    id="carrierForm"
    ref="carrierForm"
    tag="form"
    class="page_container_wrapper"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <transition name="fade-in-up">
      <div v-if="!showThanksPage" class="page_container">
        <step-intro :step.sync="form.intro"></step-intro>

        <step-questions
          :step.sync="form.questions"
          style="margin-top:75px"
        ></step-questions>

        <step-vehicle-info
          :step.sync="form.vehicleInfo"
          style="margin-top:75px"
        ></step-vehicle-info>

        <step-company-information
          :step.sync="form.companyInformation"
          style="margin-top:75px"
        ></step-company-information>

        <vvs-recaptcha
          v-if="showRecaptcha"
          name="Google Recaptcha"
          validate="required"
          v-model="googleVerifyKey"
          style="margin-top:75px"
        ></vvs-recaptcha>

        <div style="margin-top:75px">
          <vvs-submit-button
            title="BAŞVURUYU TAMAMLAYIN"
            description="* doldurulması zorunlu alan"
          ></vvs-submit-button>
        </div>
      </div>
      <step-thanks v-else></step-thanks>
    </transition>
  </validation-observer>
</template>

<script>
import StepIntro from './intro/';
import StepQuestions from './questions/';
import StepVehicleInfo from './vehicleInfo/';
import StepCompanyInformation from './companyInformation/';
import StepThanks from './thanks/';

export default {
  name: 'ApplicationsCarrierSteps',
  components: {
    StepIntro,
    StepQuestions,
    StepVehicleInfo,
    StepCompanyInformation,
    StepThanks,
  },
  data() {
    return {
      googleVerifyKey: null,
      showRecaptcha: false,
      form: {},
      showThanksPage: false,
    };
  },
  computed: {
    steps() {
      return this.$store.getters['carrier/getAllSteps'];
    },
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$refs.carrierForm.validate();

      if (isValid) {
        await this.$store.commit('setIsAppLoading', true);
        await this.$store.dispatch('carrier/createApplication', {
          application: {
            items: [
              {
                steps: await this.getStepsForSave(),
              },
            ],
          },
        });
        await this.$store.commit('setIsAppLoading', false);
        this.showThanksPage = true;
      }

      this.setNotify({ isValid });
    },
    async getStepsForSave() {
      return new Promise(resolve => {
        let form = JSON.parse(JSON.stringify(this.form));

        form.intro.isCompleted = true;
        form.questions.isCompleted = true;
        form.vehicleInfo.isCompleted = true;
        form.companyInformation.isCompleted = true;

        form.vehicleInfo.vehicles = form.vehicleInfo.vehicles.map(vehicle => {
          return {
            ...vehicle,
            type: vehicle.type.id,
          };
        });

        resolve(form);
      });
    },
    setNotify({ isValid }) {
      if (isValid) {
        this.$notify({
          title: 'Taşıyıcı Ol Başvuru Formu',
          text: 'Form başarıyla kaydedildi',
          type: 'success',
        });
        setTimeout(() => {
          this.$scrollTo('body');
        });
      } else {
        this.$notify({
          title: 'Taşıyıcı Ol Başvuru Formu',
          text: 'Lütfen formdaki bütün zorunlu alanları doldurunuz.',
          type: 'danger',
          ignoreDuplicates: true,
        });
        setTimeout(() => {
          this.$scrollTo('.form_group_wrapper__error', { offset: -20 });
        });
      }
    },
  },
  watch: {
    steps: {
      handler() {
        this.form = JSON.parse(JSON.stringify(this.steps));
      },
      deep: true,
    },
  },
  created() {
    this.googleVerifyKey = this.$store.getters['carrier/getId']
      ? this.$store.getters['getGoogleVerifyKey']
      : null;
    this.showRecaptcha = !this.googleVerifyKey;

    this.form = JSON.parse(JSON.stringify(this.steps));
  },
};
</script>
